import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../styles/SubscriptionContainer.module.scss';
import { usePurchaseSubscriptionContext } from '../../../PurchaseSubscription/context/PurchaseSubscriptionContext';
import Button from '../../../../components/Button';
import { SubscriptionAppBarSpacer } from '../../components/SubscriptionAppBar';
import { inAppCancellation as events } from '../../../../lib/analytics/events';

export default function MultidogDiscountConfirmation() {
  const { t } = useTranslation();
  const { device } = usePurchaseSubscriptionContext();

  return (
    <>
      <div className={styles.fullWidthWrapper}>
        <SubscriptionAppBarSpacer />
        <div className={styles.subscriptionContainer}>
          <h1>{t('multi_dog_discount_applied')}</h1>
          <p>
            {t('thank_you_for_being_a_fi_member_your_multi_dog_discount_will_be_applied_to_all_memberships_at_renewal')}
          </p>
        </div>

        <div className={styles.buttonContainer}>
          <Button
            className={styles.button}
            onClick={() => {
              events.multidogDiscountConfirmationDoneClicked({ petId: device.pet?.id });
              window.open('fi://closeappview');
            }}
          >
            {t('done')}
          </Button>
          {/* Spacer ensures primary button is aligned with buttons on neighboring pages in in-app cancel flow */}
          <div className={styles.buttonSpacer}></div>
        </div>
      </div>
    </>
  );
}
